export default __webpack_public_path__ + "static/media/logout.1f02cd66.svg";